// One name per area, regardless of Forklaret/Teknisk — having the label
// itself change with the mode toggle read as inconsistent rather than
// useful. Shared by every page with an area tab strip (Arbejdskø,
// Detaljeret visning) so they never drift apart.
export const AREA_LABEL = {
  identity: 'Brugere',
  devices: 'Enheder',
  security: 'Sikkerhed',
  exchange: 'E-mail',
  sharepoint: 'Grupper',
  applications: 'Entra ID Apps',
  roles: 'Roller',
  'conditional-access': 'Loginregler',
  licenses: 'Licenser',
};

// The same names for the filter-tab row (there is only one name per area).
export const AREA_TAB_LABEL = AREA_LABEL;

// Where each area's data is read from, shown under the area name everywhere (Konfiguration, Compliance).
export const AREA_PRODUCT = {
  identity: 'Entra ID',
  devices: 'Intune',
  security: 'Defender og Entra ID',
  sharepoint: 'SharePoint og Teams',
  applications: 'Entra ID',
  roles: 'Entra ID',
  exchange: 'Exchange Online og DNS',
  'conditional-access': 'Entra ID',
};

// A requirement or control that cannot be placed in one of the areas above lands here. It is never
// silently put under the nearest area: "Andet" is honest about not knowing.
export const OTHER_AREA = 'other';

export const AREA_ICON = {
  identity: 'user',
  devices: 'laptop',
  security: 'shield',
  exchange: 'mail',
  sharepoint: 'sharepoint',
  applications: 'apps',
  roles: 'crown',
  'conditional-access': 'key',
  licenses: 'tag',
};

// Call sites still pass a second `mode` argument — harmless, since
// there's only one name per area now and JS ignores the extra arg.
export function areaLabel(area) {
  if (area === OTHER_AREA) return 'Andet';
  return AREA_LABEL[area] || area;
}

export function areaTabLabel(area) {
  if (area === OTHER_AREA) return 'Andet';
  return AREA_TAB_LABEL[area] || area;
}
